import React from "react";
import { Box } from "@mui/material";
import { useFeatureFlag } from "../utils/FeatureFlagHelper";
import { HEADER_HEIGHT_CSS_VAR } from "../constants";

function MainContainer({
  children,
  isDrawerOpen,
}: {
  children: React.ReactNode;
  isDrawerOpen: boolean;
}) {
  const { enabled: unityHeader } = useFeatureFlag(
    "synergists.unity-header",
    false,
  );

  if (unityHeader) {
    return (
      <Box
        id="main-container" //The id value is important for MuiDataGrid's sticky header
        marginLeft={isDrawerOpen ? 0 : 0}
        padding={(theme) => theme.spacing(3, 0, 0)}
        overflow="auto"
        position="fixed"
        // Reserves space for both the fixed courtesy header (HEADER_HEIGHT_CSS_VAR, set by
        // CourtesyNavigationHeader) and the ecom TopNavMenu bar (48px dense toolbar) rendered
        // directly beneath it, so page content never starts underneath the ecom bar.
        top={`calc(var(${HEADER_HEIGHT_CSS_VAR}, 108px) + 48px)`}
        left={0}
        right={0}
        bottom={0}
      >
        {children}
      </Box>
    );
  }
  return (
    <Box
      id="main-container" //The id value is important for MuiDataGrid's sticky header
      marginLeft={isDrawerOpen ? 31.25 : 0}
      padding={(theme) => theme.spacing(3, 3, 4)}
      overflow="auto"
      position="relative"
      top={"50px"}
      height={"calc(100vh - 50px)"}
    >
      {children}
    </Box>
  );
}

export default MainContainer;
